<script>
import CardContent from '../Content/CardContent.vue'
import CollapsableContent from '../Content/CollapsableContent.vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import TableButtons from './TableButtons.vue'
import TableSubMenu from './TableSubMenu.vue'
import TableFilters from './TableFilters.vue'

export default {
  components: { TableFilters, TableSubMenu, TableButtons, CollapsableContent, CardContent },
  mixins: [mixinComponent],
  props: {
    filterOptions: {
      type: Object,
      default: () => ({}),
    },
    submenuLabels: {
      type: Array,
      default: [],
    },
    showCalendarFilter: {
      type: Boolean,
      default: true,
    },
    showFiltersButton: {
      type: Boolean,
      default: true,
    },
    showDownloadButton: {
      type: Boolean,
      default: true,
    },
    showFilters: {
      type: Boolean,
      default: true,
    },
    filters: {
      type: Array,
      default: [],
    },
    filterValues: {
      type: Object,
      default: () => ({}),
    },
    endpoint: {
      type: String,
      default: '',
    },
    status: {
      type: [String, Number],
      default: 0,
    },
  },
  emits: ['update:status', 'set-date', 'set-selected-status', 'download', 'update-filter-data'],
  data() {
    return {
      isFilterCollapsed: true,
      createdAt: null,
      createdAtEnd: null,
    }
  },

  methods: {
    setActive(value) {
      this.$emit('set-selected-status', parseInt(value))
      this.$emit('update:status', parseInt(value))
    },
    toggleCollapse() {
      this.isFilterCollapsed = !this.isFilterCollapsed
    },
    download() {
      this.$emit('download')
    },
    updateData(filters) {
      this.$emit('update-filter-data', filters)
    },
    setDateDataTable(fromValue, toValue) {
      this.$emit('set-date', fromValue, toValue)
    },
  },
}
</script>
<template>
  <CardContent>
    <div style="padding-top: 1.25em; padding-bottom: 1.25em">
      <div class="row">
        <div class="col-3 d-flex justify-content-start">
          <TableButtons
            v-if="showDownloadButton || showFiltersButton"
            :download-toggle="showDownloadButton"
            :filters-toggle="showFiltersButton"
            @download="download"
            @toggle-collapse="toggleCollapse"
          />
        </div>
        <div class="col-6 d-flex justify-content-center">
          <TableSubMenu :status="status" :submenu-labels="submenuLabels" @update:status="setActive" />
        </div>
        <div class="col-3 d-flex justify-content-end">
          <slot name="right"></slot>
        </div>
      </div>
      <CollapsableContent v-if="endpoint" :is-collapsed="isFilterCollapsed">
        <div class="row" style="padding-top: 1.25em">
          <TableFilters
            v-if="showFilters"
            :filters="filters"
            :filter-values="filterValues"
            :endpoint="endpoint"
            :filter-options="filterOptions"
            :show-calendar-filter="showCalendarFilter"
            @update-data="updateData"
            @set-date="setDateDataTable"
          />
        </div>
      </CollapsableContent>
    </div>
  </CardContent>
</template>
